import { render, staticRenderFns } from "./PreCharges.vue?vue&type=template&id=3b9f9cb5&"
import script from "./PreCharges.vue?vue&type=script&lang=js&"
export * from "./PreCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports